import { useEffect, useState } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import StatisticsService from "../../../services/statistics.service";
import StatCard from "./StatCard";

export default function FirstTimeMembersStat() {
  const [value, setValue] = useState(null);
  const [description, setDescription] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    StatisticsService.getTotalFirstTimeActiveMembers().then(({ data, description, error }) => {
      if (error) setError(error);
      else {
        setValue(data);
        setDescription(description);
      }
    });
  }, []);

  return (
    <StatCard
      icon={PersonAddIcon}
      value={value}
      label="Usuarios no recurrentes con membresía activa"
      description={description}
      error={error}
      iconColor="secondary.main"
    />
  );
}
